/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-29 15:04:38
 *
 *******************************************************/
// @flow

export const NUMBER_CUSTOM_SORTING = 20;

export const SORT_TYPES_UNIQUE = ['relevance', 'best-selling', 'manual'];
export const DEFAULT_SORT_TYPES = [
  'relevance',
  'best-selling',
  'manual',
  'price',
  'title',
  'created'
];

const SORT_ORDER = [
  {
    value: 'ascending',
    label: 'AdminHTML.CustomSorting.Constants.sortOrder_Ascending'
  },
  {
    value: 'descending',
    label: 'AdminHTML.CustomSorting.Constants.sortOrder_Descending'
  }
];

const SORT_ALPHABETICAL_ORDER = [
  {
    value: 'ascending',
    label: 'AdminHTML.CustomSorting.Constants.sortAlphabeticalOrder_Ascending'
  },
  {
    value: 'descending',
    label: 'AdminHTML.CustomSorting.Constants.sortAlphabeticalOrder_Descending'
  }
];

const SORT_NUMBER_ORDER = [
  { value: 'ascending', label: 'AdminHTML.CustomSorting.Constants.sortNumberOrder_Ascending' },
  { value: 'descending', label: 'AdminHTML.CustomSorting.Constants.sortNumberOrder_Descending' }
];

const SORT_DAY_ORDER = [
  { value: 'ascending', label: 'AdminHTML.CustomSorting.Constants.sortDayOrder_Ascending' },
  { value: 'descending', label: 'AdminHTML.CustomSorting.Constants.sortDayOrder_Descending' }
];

export const SORT_TYPES_ORDER = {
  relevance: [],
  'best-selling': [],
  manual: [],
  price: SORT_NUMBER_ORDER,
  title: SORT_ALPHABETICAL_ORDER,
  created: SORT_DAY_ORDER,
  tag: SORT_ORDER,
  vendor: SORT_ALPHABETICAL_ORDER,
  ratings: SORT_NUMBER_ORDER,
  'published-date': SORT_DAY_ORDER,
  'percent-sale': SORT_NUMBER_ORDER,
  metafield: SORT_ORDER,
  'empty-metafield': [],
  'product-type': SORT_ALPHABETICAL_ORDER,
  'product-category': SORT_ALPHABETICAL_ORDER
};

export const DATA_TYPES = [
  { value: 'number', label: 'AdminHTML.CustomSorting.Constants.dataTypes_Number' },
  { value: 'string', label: 'AdminHTML.CustomSorting.Constants.dataTypes_String' }
];

export const SORT_TYPES_LABEL = {
  relevance: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Relevance',
  'best-selling': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_BestSelling',
  manual: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Manual',
  price: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Price',
  title: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Title',
  created: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Created',
  tag: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Tag',
  vendor: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Vendor',
  ratings: 'AdminHTML.CustomSorting.Constants.sortTypesLabel_Ratings',
  'published-date': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_PublishedDate',
  'percent-sale': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_PercentSale',
  'empty-metafield': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_EmptyMetafield',
  'product-type': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_ProductType',
  'product-category': 'AdminHTML.CustomSorting.Constants.sortTypesLabel_ProductCategory'
};
